import { render, staticRenderFns } from "./other-prods.vue?vue&type=template&id=7580e997&scoped=true"
import script from "./other-prods.vue?vue&type=script&lang=js"
export * from "./other-prods.vue?vue&type=script&lang=js"
import style0 from "./other-prods.vue?vue&type=style&index=0&id=7580e997&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7580e997",
  null
  
)

export default component.exports